import { render, staticRenderFns } from "./DocumentoPreAtendimento.vue?vue&type=template&id=0c66e31c&"
import script from "./DocumentoPreAtendimento.vue?vue&type=script&lang=js&"
export * from "./DocumentoPreAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports